import { IntlShape } from 'react-intl'

import { ServiceProvisionUnitEnum } from '../lib/graphql'

export const provisionUnitToLabel = ({
  unit,
  fullLabel,
  intl,
}: {
  unit: ServiceProvisionUnitEnum
  fullLabel?: boolean
  intl: IntlShape
}) => {
  switch (unit) {
    case ServiceProvisionUnitEnum.INDIVIDUAL:
      return fullLabel
        ? intl.formatMessage({
            id: 'ui.provisionUnitToLabel.individualFullLabel',
            defaultMessage: ' / personne',
          })
        : intl.formatMessage({
            id: 'ui.provisionUnitToLabel.individual',
            defaultMessage: '/pers.',
          })
    case ServiceProvisionUnitEnum.GROUP:
      return fullLabel
        ? intl.formatMessage({
            id: 'ui.provisionUnitToLabel.groupFullLabel',
            defaultMessage: ' / prestation',
          })
        : intl.formatMessage({
            id: 'ui.provisionUnitToLabel.group',
            defaultMessage: '/presta.',
          })
    case ServiceProvisionUnitEnum.DAILY:
      return fullLabel
        ? intl.formatMessage({
            id: 'ui.provisionUnitToLabel.dailyFullLabel',
            defaultMessage: ' / jour',
          })
        : intl.formatMessage({
            id: 'ui.provisionUnitToLabel.daily',
            defaultMessage: '/jour',
          })
    case ServiceProvisionUnitEnum.HALF_DAY:
      return fullLabel
        ? intl.formatMessage({
            id: 'ui.provisionUnitToLabel.halfDaylFullLabel',
            defaultMessage: ' / demi-journée',
          })
        : intl.formatMessage({
            id: 'ui.provisionUnitToLabel.halfDay',
            defaultMessage: '/demi-jour.',
          })
    case ServiceProvisionUnitEnum.NIGHT:
      return fullLabel
        ? intl.formatMessage({
            id: 'ui.provisionUnitToLabel.nightFullLabel',
            defaultMessage: ' / nuit',
          })
        : intl.formatMessage({
            id: 'ui.provisionUnitToLabel.night',
            defaultMessage: '/nuit',
          })
    case ServiceProvisionUnitEnum.ROOM:
      return fullLabel
        ? intl.formatMessage({
            id: 'ui.provisionUnitToLabel.roomFullLabel',
            defaultMessage: ' / pièce',
          })
        : intl.formatMessage({
            id: 'ui.provisionUnitToLabel.room',
            defaultMessage: '/pièce',
          })
    case ServiceProvisionUnitEnum.SOJOURN:
      return fullLabel
        ? intl.formatMessage({
            id: 'ui.provisionUnitToLabel.sojournFullLabel',
            defaultMessage: ' / séjour',
          })
        : intl.formatMessage({
            id: 'ui.provisionUnitToLabel.sojourn',
            defaultMessage: '/séjour',
          })
    case ServiceProvisionUnitEnum.INCLUDED:
      return intl.formatMessage({
        id: 'ui.provisionUnitToLabel.included',
        defaultMessage: 'inclus',
      })
    default:
      return intl.formatMessage({
        id: 'ui.provisionUnitToLabel.default',
        defaultMessage: 'unité inconnue',
      })
  }
}
